// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../react-forms/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../react-forms/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.incoming-leads {
    background-color: white;
    padding: 10px;
    border-radius: 3px;
}

.incoming-leads select {
    width: 100%;
}

.incoming-leads .label {
    padding-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./../css/teams-channel-selector.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".incoming-leads {\n    background-color: white;\n    padding: 10px;\n    border-radius: 3px;\n}\n\n.incoming-leads select {\n    width: 100%;\n}\n\n.incoming-leads .label {\n    padding-bottom: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
